<template>
  <footer class="c-footer">
    <b-row class="c-footer__copy" style="width:100%">
      <b-col md="3">
        &copy; <strong>MTG AG</strong>
      </b-col>
      <b-col md="6" class="text-center">
        <span class="custom-font">{{ $t("lang.label_footer_funded_by_1") }}</span>
        <span class="custom-font">  {{ $t("lang.label_footer_funded_by_2") }} </span>
      </b-col>
      <b-col md="3">
        <nav class="c-footer__nav">
          <ul class="list-unstyled">
            <li>
              <a v-bind:href="'https://www.mtg.de/' + $store.state.locale + '/' + $t('lang.label_footer_legalNotice') + '/index.html'">{{ $t("lang.label_footer_legalNoticeFooter") }}</a>
            </li>
            <li>
              <a v-bind:href="'https://www.mtg.de/' + $store.state.locale + '/' + $t('lang.label_footer_dataPrivacy') + '/index.html'">{{ $t("lang.label_footer_dataPrivacyFooter") }}</a>
            </li>
            <li>
              <router-link :to="{ name: 'terms-conditions', params: { previousPage: 'login-and-registration' } }">{{ $t("lang.label_footer_termsConditions") }}</router-link>
            </li>
          </ul>
        </nav>
      </b-col>
    </b-row>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent"
};
</script>

<style scoped>
.custom-font {
  font-size: 13px;
}

@media (min-width: 1440px) {
  .custom-font{
    display: block;
  }
}
</style>
